import { Auth, AuthConfig } from '@foxcorp/foxkit-auth-js';

import { getUiConfig } from '@/config/client/getUiConfig';

import { configOptions } from './configOptions';
import { statefulRefreshToken } from './statefulRefreshToken';

let authSDK: Auth | null = null;

export function getAuthSDK(): Auth {
  if (authSDK) {
    return authSDK;
  }

  const config = new AuthConfig({
    ...configOptions,

    environment: getUiConfig().environmentAlt,
    statefulRefreshToken,
    useEksEndPoints: true,
  });

  authSDK = new Auth(config);

  return authSDK;
}
